import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLayoutEffect, useRef, useState, useEffect } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useAuth } from "../../contexts/AuthContext";
// import testimonialImg1 from "../../assets/image/testimony/testim-3.jpg";
// import testimonialImg2 from "../../assets/image/testimony/testim-3.jpg";
// import testimonialImg3 from "../../assets/image/testimony/testim-3.jpg";
import featureImg1 from "../../assets/image/feature/feature-1.png";
import featureImg2 from "../../assets/image/feature/feature-2.png";
import featureImg3 from "../../assets/image/feature/feature-3.png";
import featureImg4 from "../../assets/image/feature/feature-4.png";
import featureImg5 from "../../assets/image/feature/feature-5.png";
import featureImg6 from "../../assets/image/feature/feature-6.png";
import featureImg7 from "../../assets/image/feature/feature-7.png";
import featureImg8 from "../../assets/image/feature/feature-8.png";
import medialogo1 from "../../assets/image/edo.png";
import medialogo2 from "../../assets/image/edo_ministry.png";
import medialogo3 from "../../assets/image/esosa.png";
import medialogo4 from "../../assets/image/google.png";
import medialogo5 from "../../assets/image/pic.png";
import HexGrid from "./HexGrid";
import api from "../../utils/api";
import { FaBriefcase, FaExternalLinkAlt, FaQuoteRight, FaArrowRight } from "react-icons/fa";
import "../graduatedProjects/Graduatedproject.css";

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  const heroVideoVisual = useRef(null);
  const { isAuthenticated, accountType } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        const response = await api.get("/graduate-projects");
        if (response.data && response.data.data) {
          setProjects(response.data.data);
        } else {
          setProjects(response.data || []);
        }
      } catch (err) {
        setError("Unable to load graduate projects.");
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (window.innerWidth >= 1024) {
        gsap.fromTo(
          heroVideoVisual.current,
          { scale: 0.75, borderRadius: "1.2rem", y: -90 },
          {
            scrollTrigger: {
              trigger: heroVideoVisual.current,
              start: "-20% center",
              end: "50% center",
              toggleActions: "play none none reverse",
            },
            scale: 1,
            borderRadius: 0,
            y: 0,
            ease: "power2.out",
          },
        );
      }
    }, heroVideoVisual);

    return () => ctx.revert();
  }, []);

  return (
    <div className="home">
      <HexGrid />
      <section className="hero-section-wrapper">
        <div className="">
          <div className="hero-section-content">
            <h1 className="js-scroll fade-in">
              Your Journey To Tech Confidence Starts Here
            </h1>
            <p>
              Master AI and Machine Learning with a program built for African excellence, offering the real-world experience and expert mentorship you need to lead the world’s fastest-growing industry
            </p>
            <div className="hero-buttons mb-lg-0 mb-4 d-flex flex-wrap gap-2 justify-content-center justify-content-lg-center">
              {isAuthenticated ? (
                <>
                  <Link to="/cohorts" className="register-btn">
                    Register for Courses
                  </Link> 
                  <Link to="/organizations-landing" className="mentors-btn">
                    Register as Organization
                  </Link>
                  <Link to="/private-courses" className="mentors-btn">
                    Register for Private Class
                  </Link> 
                </>
              ) : (
                <>
                  <Link to="/cohorts" className="register-btn">
                    Register for Cohort
                  </Link>
                  <Link to="/organizations-landing" className="mentors-btn">
                    Register as Organization
                  </Link>
                  <Link to="/private-courses" className="mentors-btn">
                    Register for Private Class
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>

        <section className="home-hero-video-section">
          <div className="home-hero_visual">
            <video
              muted
              loop
              autoPlay
              className="inline-video_video"
              ref={heroVideoVisual}
            >
              <source src="/video/home-hero.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </section>
      </section>

      <section className="what-you-get">
        <div className="container-fluid py-5">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="what-you-get-title js-scroll fade-in-bottom">
                What You'll Get
              </h2>
              <p className="what-you-get-subtitle js-scroll fade-in-bottom">
                From immersive live sessions to one-on-one mentorship with Africa’s tech elite, our ecosystem provides the blueprint for your journey from student to high-impact tech leader.
              </p>
            </div>
          </div>
          <div className="feature-slider-wrapper">
            <button className="swiper-button-prev-custom feature-slider-arrow feature-slider-prev">
              <i className="lni lni-chevron-left"></i>
            </button>
            <button className="swiper-button-next-custom feature-slider-arrow feature-slider-next">
              <i className="lni lni-chevron-right"></i>
            </button>

            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={3}
              navigation={{
                nextEl: ".swiper-button-next-custom",
                prevEl: ".swiper-button-prev-custom",
                enabled: true,
              }}
              pagination={{
                clickable: true,
                el: ".swiper-pagination-custom",
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              breakpoints={{
                320: { slidesPerView: 1, spaceBetween: 20 },
                480: { slidesPerView: 1, spaceBetween: 20 },
                768: { slidesPerView: 1, spaceBetween: 20 },
                1024: { slidesPerView: 2, spaceBetween: 30 },
                1280: { slidesPerView: 3, spaceBetween: 30 },
              }}
            >
              <SwiperSlide>
                <div className="feature-card">
                  <div className="feature-card-bg">
                    <img src={featureImg1} className="u-img-cover" alt="" />
                  </div>
                  <div className="u-bg-blur cc-accordion-card"></div>
                  <div className="feature-card-content">
                    <i className="lni lni-video"></i>
                    <h3>Annual Live Training</h3>
                    <p>
                      Participate in live, interactive training sessions with
                      our expert instructors.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="feature-card cursor-target">
                  <div className="feature-card-bg">
                    <img
                      src={featureImg2}
                      className="u-img-cover"
                      alt="Rewatch & Assignment Access"
                    />
                  </div>
                  <div className="u-bg-blur cc-accordion-card"></div>
                  <div className="feature-card-content">
                    <i className="lni lni-play"></i>
                    <h3>Rewatch & Assignment Access</h3>
                    <p>
                      Access recordings of all sessions and complete assignments
                      at your own pace.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="feature-card cursor-target">
                  <div className="feature-card-bg">
                    <img
                      src={featureImg3}
                      className="u-img-cover"
                      alt="Human + AI Mentorship"
                    />
                  </div>
                  <div className="u-bg-blur cc-accordion-card"></div>
                  <div className="feature-card-content">
                    <i className="lni lni-users"></i>
                    <h3>Human + AI Mentorship</h3>
                    <p>
                      Receive guidance and support from both human mentors and
                      our AI-powered tutor.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="feature-card cursor-target">
                  <div className="feature-card-bg">
                    <img
                      src={featureImg4}
                      className="u-img-cover"
                      alt="Organization Training Options"
                    />
                  </div>
                  <div className="u-bg-blur cc-accordion-card"></div>
                  <div className="feature-card-content">
                    <i className="lni lni-graduation"></i>
                    <h3>Organization Training Options</h3>
                    <p>
                      Equip your team with the latest AI skills through our
                      tailored training programs.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="feature-card cursor-target">
                  <div className="feature-card-bg">
                    <img
                      src={featureImg5}
                      className="u-img-cover"
                      alt="Certificate of Completion"
                    />
                  </div>
                  <div className="u-bg-blur cc-accordion-card"></div>
                  <div className="feature-card-content">
                    <i className="lni lni-certificate"></i>
                    <h3>Certificate of Completion</h3>
                    <p>
                      Earn a professional certificate to showcase your new
                      skills and knowledge.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="feature-card cursor-target">
                  <div className="feature-card-bg">
                    <img
                      src={featureImg6}
                      className="u-img-cover"
                      alt="Performance Tracking"
                    />
                  </div>
                  <div className="u-bg-blur cc-accordion-card"></div>
                  <div className="feature-card-content">
                    <i className="lni lni-graph"></i>
                    <h3>Performance Tracking</h3>
                    <p>
                      Monitor your progress and identify areas for improvement
                      with our performance tracking tools.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="swiper-pagination-custom"></div>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 my-3 text-center">
              <h2 className="how-it-works-title js-scroll fade-in-bottom">
                How It Works
              </h2>
              <p className="how-it-works-subtitle js-scroll fade-in">
                Comprehensive AI training solutions tailored for individuals and
                organizations
              </p>
            </div>
          </div>
          <div className="row how-it-works-content">
            <div className="col-lg-6 how-it-works-image-wrapper">
              <div className="how-it-works-image-container">
                <img
                  src={featureImg7}
                  alt="Build web experiences"
                  className="how-it-works-image active"
                  id="offer-image-1"
                />
                <img
                  src={featureImg8}
                  alt="Create and manage content"
                  className="how-it-works-image"
                  id="offer-image-2"
                />
                <img
                  src={featureImg1}
                  alt="Empower with templates"
                  className="how-it-works-image"
                  id="offer-image-3"
                />
                <img
                  src={featureImg6}
                  alt="Generate with AI"
                  className="how-it-works-image"
                  id="offer-image-4"
                />
              </div>
            </div>
            <div className="col-lg-6 how-it-works-text-wrapper">
              <div className="how-it-works-items">
                <div
                  className="how-it-works-item js-scroll fade-in-bottom"
                  onMouseEnter={() => {
                    document
                      .querySelectorAll(".how-it-works-image")
                      .forEach((img) => img.classList.remove("active"));
                    document
                      .getElementById("offer-image-1")
                      .classList.add("active");
                  }}
                >
                  <h3>Register For A Cohort</h3>
                  <p>
                    Choose your preferred training track and complete a quick
                    registration to secure your spot.
                  </p>
                </div>
                <div
                  className="how-it-works-item js-scroll fade-in-bottom"
                  onMouseEnter={() => {
                    document
                      .querySelectorAll(".how-it-works-image")
                      .forEach((img) => img.classList.remove("active"));
                    document
                      .getElementById("offer-image-2")
                      .classList.add("active");
                  }}
                >
                  <h3>Access Learning Dashboard</h3>
                  <p>
                    Confirm payment and gain hands-on access to a personalized
                    dashboard where all your enrolled courses, schedules, and
                    online class details are clearly mapped out.
                  </p>
                </div>
                <div
                  className="how-it-works-item js-scroll fade-in-bottom"
                  onMouseEnter={() => {
                    document
                      .querySelectorAll(".how-it-works-image")
                      .forEach((img) => img.classList.remove("active"));
                    document
                      .getElementById("offer-image-3")
                      .classList.add("active");
                  }}
                >
                  <h3>Join Live Sessions</h3>
                  <p>
                    Learn directly from industry experts through engaging live
                    classes and practical projects.
                  </p>
                </div>
                <div
                  className="how-it-works-item js-scroll fade-in-bottom"
                  onMouseEnter={() => {
                    document
                      .querySelectorAll(".how-it-works-image")
                      .forEach((img) => img.classList.remove("active"));
                    document
                      .getElementById("offer-image-4")
                      .classList.add("active");
                  }}
                >
                  <h3>Track Learning Progress And Get Certified</h3>
                  <p>
                    Relive class moments through recorded sessions, celebrate
                    milestones, and watch your growth unfold. Earn your
                    certificate and step into the next stage of your career
                    equipped with job-ready AI skills.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="media-partners-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="media-partners-title">Where Our Alumni Work</h2>
              <p className="media-partners-subtitle js-scroll fade-in">
                Graduates from our programs now contribute to leading
                organizations, shaping the future of technology and innovation
                across Africa and beyond.
              </p>
            </div>
          </div>
          <div className="media-partners-grid js-scroll fade-in-bottom">
            <div className="media-partner-item">
              <div className="media-partner-logo">
                <Link to="https://datasciencenigeria.org/" target="_blank"><img src={medialogo1} alt="" /></Link>
              </div>
            </div>
            <div className="media-partner-item">
              <div className="media-partner-logo">
                <Link to="https://edo.ng/" target="_blank"><img src={medialogo2} alt="" /></Link>
              </div>
            </div>
            <div className="media-partner-item">
              <div className="media-partner-logo">
                <Link to="https://esosafoodsystems.com/" target="_blank"><img src={medialogo3} alt="" /></Link>
              </div>
            </div>
            <div className="media-partner-item">
              <div className="media-partner-logo">  
                <Link to="https://gdg.community.dev/gdg-benin/" target="_blank"><img src={medialogo4} alt="" /></Link>
              </div>
            </div>
            <div className="media-partner-item">
              <div className="media-partner-logo">
                <Link to="https://policycentre.org/" target="_blank"><img src={medialogo5} alt="" /></Link>
              </div>
            </div>
            <div className="media-partner-item">
              <div className="media-partner-logo">
                <Link to="https://gritinai.com/" target="_blank"><img src="/logo.png" alt="" /></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Graduate Projects Section */}
      <section className="featured-projects-section">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <span className="featured-projects-badge">Alumni Projects</span>
              <h2 className="featured-projects-title mt-3">Featured Graduate Showcases</h2>
              <p className="featured-projects-subtitle js-scroll fade-in mx-auto mt-2" style={{ maxWidth: '650px' }}>
                Discover how GritinAI graduates are putting their skills to work, building groundbreaking capstone projects, and designing tech innovations across Africa.
              </p>
            </div>
          </div>

          {loading ? (
            <div className="graduated-projects-grid">
              {[1, 2, 3].map((i) => (
                <div key={i} className="graduated-project-skeleton-card">
                  <div className="skeleton-avatar" />
                  <div className="skeleton-line title-line" />
                  <div className="skeleton-line badge-line" />
                  <div className="skeleton-line text-line" />
                  <div className="skeleton-line text-line short" />
                  <div className="skeleton-btn" />
                </div>
              ))}
            </div>
          ) : error ? (
            <div className="text-center py-5 text-danger font-weight-bold">
              <p>⚠️ {error}</p>
            </div>
          ) : projects.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <p>Our recent graduates are preparing their capstones. Stay tuned to discover their projects!</p>
            </div>
          ) : (
            <div className="featured-projects-swiper-wrapper position-relative px-4">
              <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={30}
                slidesPerView={3}
                autoplay={{
                  delay: 4500,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                pagination={{
                  clickable: true,
                  dynamicBullets: true,
                }}
                navigation={true}
                loop={projects.length >= 3}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 20 },
                  768: { slidesPerView: 2, spaceBetween: 25 },
                  1024: { slidesPerView: 3, spaceBetween: 30 },
                }}
                className="pb-5"
              >
                {projects.map((project) => (
                  <SwiperSlide key={project.id} className="h-auto">
                    <div className="graduated-project-premium-card h-100" style={{ margin: '15px 0' }}>
                      <div className="card-top-accent" />
                      <div className="card-inner">
                        {/* Backdrop Quote Icon */}
                        <div className="card-quote-icon">
                          <FaQuoteRight />
                        </div>

                        {/* Graduate Identity */}
                        <div className="graduate-identity">
                          {project.image ? (
                            <div className="graduate-avatar-container">
                              <img
                                src={project.image}
                                alt={project.name}
                                className="graduate-avatar"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                  const fallback = e.target.nextSibling;
                                  if (fallback) fallback.style.display = "flex";
                                }}
                              />
                              <div className="graduate-avatar-fallback" style={{ display: "none" }}>
                                {project.name.substring(0, 2).toUpperCase()}
                              </div>
                            </div>
                          ) : (
                            <div className="graduate-avatar-fallback">
                              {project.name.substring(0, 2).toUpperCase()}
                            </div>
                          )}
                          <div className="graduate-meta">
                            <h3 className="graduate-name" style={{ fontSize: '1.1rem' }}>{project.name}</h3>
                            <div className="graduate-badge">
                              <FaBriefcase className="badge-icon" />
                              <span>{project.title}</span>
                            </div>
                          </div>
                        </div>

                        {/* Description Testimony */}
                        <p className="graduate-description" style={{ fontSize: '0.92rem' }}>
                          {project.description}
                        </p>

                        {/* Action Link */}
                        {project.link && (
                          <div className="graduate-action">
                            <a
                              href={project.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="graduate-link-btn"
                            >
                              View Project / Profile
                              <FaExternalLinkAlt className="btn-arrow" />
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* View More Projects Button */}
              <div className="text-center mt-4">
                <Link to="/graduated-projects" className="featured-projects-view-all-btn">
                  Explore All Alumni Projects
                  <FaArrowRight className="ms-2" style={{ fontSize: '0.85rem' }} />
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* <section className="testimonials pt-50 pb-50 ">
        <div className="container js-scroll fade-in-bottom">
          <div className="row">
            <div className="col-lg-12 my-3 justify-content-center">
              <h2 className="testimonials-title">Hear from Our Alumni</h2>
            </div>
          </div>
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={50}
            slidesPerView={3}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            loop={true}
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 20 },
              600: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 1, spaceBetween: 30 },
              1024: { slidesPerView: 2, spaceBetween: 40 },
              1280: { slidesPerView: 3, spaceBetween: 50 },
            }}
          >
            <SwiperSlide>
              <div className="Testimonials-card mb-3">
                <div className="Testimonials-card-content">
                  <p className="Testimonials-card-content-text mt-3">
                    GritinAI's training transformed my career. The hands-on
                    experience and expert mentorship were invaluable.
                  </p>
                  <div className="d-flex align-items-center mt-4">
                    <img
                      src={testimonialImg1}
                      className="img_profile"
                      alt="Avatar"
                    />
                    <div className="ms-3">
                      <p className="Testimonials-card-content-name mb-0">
                        Nina R
                      </p>
                      <span className="Testimonials-card-content-position">
                        Business Owner
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="Testimonials-card mb-3">
                <div className="Testimonials-card-content">
                  <p className="Testimonials-card-content-text mt-3">
                    The comprehensive curriculum and personalized support at
                    GritinAI helped me master complex AI concepts with ease.
                  </p>
                  <div className="d-flex align-items-center mt-4">
                    <img
                      src={testimonialImg2}
                      className="img_profile"
                      alt="Avatar"
                    />
                    <div className="ms-3">
                      <p className="Testimonials-card-content-name mb-0">
                        Alex J
                      </p>
                      <span className="Testimonials-card-content-position">
                        Free Lancer
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="Testimonials-card mb-3">
                <div className="Testimonials-card-content">
                  <p className="Testimonials-card-content-text mt-3">
                    I highly recommend GritinAI for anyone looking to excel in
                    AI. The practical skills I gained are directly applicable to
                    my work.
                  </p>
                  <div className="d-flex align-items-center mt-4">
                    <img
                      src={testimonialImg3}
                      className="img_profile"
                      alt="Avatar"
                    />
                    <div className="ms-3">
                      <p className="Testimonials-card-content-name mb-0">
                        Emily S
                      </p>
                      <span className="Testimonials-card-content-position">
                        Entrepreneur
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section> */}
    </div>
  );
};

export default Home;
